import { render, staticRenderFns } from "./AccountFooter.vue?vue&type=template&id=32c914c9&scoped=true"
import script from "./AccountFooter.vue?vue&type=script&lang=js"
export * from "./AccountFooter.vue?vue&type=script&lang=js"
import style0 from "./AccountFooter.vue?vue&type=style&index=0&id=32c914c9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c914c9",
  null
  
)

export default component.exports